var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import id from "@irati/utils/id";
import { AccordionHeader } from "./";
import { AccordionContent, AccordionExpander, FlushTopHr, SpacedCard } from "./styled/AccordionItem";
var AccordionItem = forwardRef(function (_a, ref) {
    var title = _a.title, isInner = _a.isInner, children = _a.children, props = __rest(_a, ["title", "isInner", "children"]);
    var idNamespace = id("AccordionItem", props);
    return (React.createElement(SpacedCard, { id: idNamespace, isInner: isInner, flush: true },
        React.createElement(AccordionExpander, { fullWidth: true, ref: ref, id: id("expander", idNamespace), showText: title, isInner: isInner, Header: AccordionHeader },
            React.createElement(AccordionContent, { id: id("content", idNamespace), isInner: isInner },
                !isInner && React.createElement(FlushTopHr, null),
                children))));
});
AccordionItem.defaultProps = {
    isInner: false
};
export default AccordionItem;
